module.exports = __webpack_public_path__ + "static/media/functional-fitness.b7d494ef.jpg";